<script>
    import { createEventDispatcher } from "svelte";
    import { params, url, goto } from "@roxi/routify";
    import tagService from "./service.js";
    import { notificate } from "../../services/notification.js";
    import { flatten422Errors } from "../../services/api.svelte.js";
    import { translateErrorMessages } from "../../services/api.svelte.js";
    import { form as svForm } from "svelte-forms";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();

    let id = $params.id;
    let formDataPromise;
    let formData = {};
    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;

    // API 422 errors
    let formApiErrors = {};

    formData.tags = "";

    // add form
    if (!id) {
        formDataPromise = Promise.resolve({});
    }

    const myForm = svForm(() => ({
        tags: { value: formData.tags, validators: ["required"] },
    }));

    // errors must be shown only when:
    //   field is invalid (dirty or after submit)
    //   or the API returned 422
    function shouldShowFieldError(field) {
        return (
            ((formIsSubmitted || field.dirty) && !field.valid) ||
            formApiErrors[field]
        );
    }

    function handleSubmit() {
        let config = {};
        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        if (!$myForm.valid) {
            notificate("422");
            return false;
        }

        if (formData.tags) {
            let tags = formData.tags.split("\n");

            if (tags.length >= 100) {
                return (APIerror =
                    "Por favor, cargue hasta 100 registros como máximo");
            }

            tags.forEach((tag, i) => {
                tag = { name: tag };
                config.massive_addition = true;
                tagService
                    .save(tag, [], config)
                    .then((tag) => {
                        //clear formData and form status and errors
                        // when modal is closed after sending add request
                        formData = {};
                        formIsSubmitted = false;
                        formApiErrors = {};
                        if (i == tags.length - 1) {
                            dispatch("save", { tag });
                        }
                        return true;
                    })
                    .catch((errors) => {
                        if (typeof errors.detail == "string") {
                            APIerror = translateErrorMessages(
                                errors.detail,
                                "tags_massive",
                            );
                        } else {
                            // parse API errors
                            formApiErrors = flatten422Errors(errors);
                        }
                        return false;
                    });
            });
        }
        formIsSubmitted = false;
        formApiErrors = {};
        APIerror = null;
        return true;
    }

    function handleCloseModal() {
        formIsSubmitted = false;
    }

    const handleKeydown = (event) => {
        if (event.key == "Escape") {
            handleCloseModal();
        } else {
            return;
        }
    };
</script>

<svelte:window on:keydown={handleKeydown} />

<form role="form" novalidate on:submit|preventDefault={handleSubmit}>
    <div class="card">
        <div class="card-body">
            {#await formDataPromise then formDataUnused}
                <div class="mb-3">
                    <label for="tags"
                        >Etiquetas<span class="text-danger">*</span></label
                    >

                    <textarea
                        type="text"
                        class="form-control"
                        id="tags"
                        name="tags"
                        placeholder="etiqueta-y&#10;&#13;etiqueta-z&#10;&#13;etiqueta-z"
                        bind:value={formData.tags}
                        disabled={formData.id}
                        class:is-invalid={shouldShowFieldError(
                            $myForm.fields.tags,
                        )}
                    />

                    {#if APIerror}
                        <div class="mt-3 text-danger" style="font-size: 80%;">
                            {APIerror}
                        </div>
                    {/if}
                    {#if shouldShowFieldError($myForm.fields.tags)}
                        {#if $myForm.fields.tags.errors.includes("required")}
                            <div class="invalid-feedback">Es requerido</div>
                        {/if}
                        {#if formApiErrors.name && formApiErrors.name.includes("value_error")}
                            <div class="invalid-feedback">
                                Etiqueta inválido.
                            </div>
                        {/if}
                    {/if}
                </div>
            {/await}
        </div>
        <div class="card-footer">
            <button type="submit" class="btn btn-primary t-submit-tag-btn"
                >{$format("buttons.save")}</button
            >
            <button
                type="button"
                class="btn btn-default"
                data-bs-dismiss="modal"
            >
                {$format("buttons.cancel")}
            </button>
        </div>
        {#await formDataPromise}
            <div class="overlay">
                <i class="fas fa-2x fa-sync-alt fa-spin" />
            </div>
        {/await}
    </div>
</form>

<style>
    textarea {
        min-height: 100px;
    }
</style>
